module.exports = __webpack_public_path__ + "static/media/av2.2a697d4b.png";